import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import { Notification, Search as SearchComponent, Typography } from '@telus-uds/components-web';
import { Table, Tbody, Tr, Td } from 'react-super-responsive-table';

import request from '../utils/request';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

import { TableWrapper } from './css';
import FieldGuide from './fields/common/fieldGuide';

const EditableSalesRepInfo = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      LIST: { searchLabelTitle, searchHintTitle }
    },
    editableSalesRepInfo: {
      selectLabel,
      enterUserError,
      noRecordFoundError,
      toolTip
    }
  } = localizedStrings;

  const [querySrting, setQueryString] = useState('');
  const [userList, setUserList] = useState([]);
  const [userSelected, setUserSelected] = useState();
  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    localStorage.removeItem('salesRepInfoForSRT');
    return () => {
      localStorage.removeItem('salesRepInfoForSRT');
    };
  }, []);

  const clearSearch = () => {
    setQueryString('');
    setUserList([]);
  };

  const onUserSelect = userInfo => {
    setUserSelected(userInfo);
    localStorage.setItem('salesRepInfoForSRT', JSON.stringify(userInfo));
    clearSearch();
  };

  const onUnSelectUser = () => {
    localStorage.removeItem('salesRepInfoForSRT');
  };

  const getUsers = () => {
    if (!querySrting) {
      setErrorMessage(enterUserError);
      setUserList([]);
      return;
    }

    request.get(`/users/for-srt-group?q=${querySrting}`).then(response => {
      const responseData = response.data.users;
      if (responseData.length === 0) {
        setErrorMessage(noRecordFoundError);
        return;
      }
      const users = response.data.users.map(user => {
        return {
          ...user,
          name: `${user.first_name} ${user.last_name}`,
          channelName: _.get(user, 'channels.0.name', '')
        };
      });
      setUserList(users);
      setErrorMessage('');
    });
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
        <div style={{ marginBottom: '0.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <p style={{ fontSize: '14px', fontWeight: '700', margin: 0 }}>
              {searchLabelTitle}
            </p>
            <FieldGuide tooltip={toolTip} />
          </div>
          {/* <p style={{ fontSize: '14px', margin: '0.25rem 0 0 0' }}>{searchHintTitle}</p> */}
        </div>
        <div style={{ maxWidth: '500px', width: '100%' }}>
          <SearchComponent
            placeholder={searchHintTitle}
            value={querySrting || ''}
            onChange={setQueryString}
            onSubmit={getUsers}
            onClear={clearSearch}
          />
        </div>
      </div>
      {errorMessage && (
        <div style={{ maxWidth: '400px', marginTop: '0.5rem' }}>
          <Notification variant={{ validation: 'error' }}>
            <Typography>{errorMessage}</Typography>
          </Notification>
        </div>
      )}
      {!errorMessage && userList.length > 0 && (
        <TableWrapper>
          <Table>
            <Tbody>
              {userList.map((user, index) => (
                <Tr
                  key={user.id}
                  style={{
                    background: index % 2 === 0 ? '#f9f1ff' : '#ffffff'
                  }}
                >
                  <Td>{user.name}</Td>
                  <Td>{user.email}</Td>
                  <Td>
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => onUserSelect(user)}
                    >
                      {selectLabel}
                    </button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableWrapper>
      )}
      {userList.length === 0 && userSelected && (
        <div style={{ width: 'fit-content' }}>
          <Notification
            variant={{ branded: true }}
            copy="en"
            dismissible
            onDismiss={onUnSelectUser}
          >
            <Typography>Order will be created on behalf of </Typography>
            <Typography variant={{ bold: true }}>{userSelected.name}</Typography>
          </Notification>
        </div>
      )}
    </>
  );
};

export default EditableSalesRepInfo;
